import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contents-search-wrapper" }
const _hoisted_2 = { class: "contents-search" }
const _hoisted_3 = { class: "contents-search-title" }
const _hoisted_4 = {
  class: "contents-search-tags",
  id: "tag_name"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "pc-only" }
const _hoisted_12 = { class: "contents-search-title" }
const _hoisted_13 = {
  class: "contents-search-writers",
  id: "nickname"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "contents-search-writers sp-only",
  id: "nickname"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "recs-contents" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "sp-wrapper-right" }
const _hoisted_21 = { class: "content-item-title" }
const _hoisted_22 = { class: "tag-container" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "sp-wrapper-bottom" }
const _hoisted_28 = { class: "content-item-date" }
const _hoisted_29 = { class: "content-item-writer" }
const _hoisted_30 = { class: "writer-name" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "like-button" }
const _hoisted_33 = ["id", "checked", "onChange"]
const _hoisted_34 = ["for"]
const _hoisted_35 = ["id", "checked", "onChange"]
const _hoisted_36 = ["for"]

import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { Tag } from "@/models/contents/tag";
import { Content } from "@/models/contents/content";
import { UserAuthorFollow } from "@/models/users/authorFollow";
import { UserDisease } from "@/models/users/disease";
import { UserArticleFavorite } from "@/models/users/articleFavorite";
import { UserArticleLike } from "@/models/users/articleLikes";
import Pagination from "@/views/base/Pagination.vue";
import { processend, processing } from "@/utils/view";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import ModalSearch from "@/components/modules/article/ModalSearch.vue";

// ---- interface ----------------------------------------------
interface ArticleData {
  articleId: number;
  title: string;
  contentType: number;
  coverPhotoUrl: string;
  likeCount: number;
  dateFirstPublished: string;
  tags: {
    tagId: number;
    tagName: string;
  }[];
  diseases: {
    diseaseCode: string;
    diseaseName: string;
  }[];
  poster: {
    adminId: number;
    nickname: string;
  };
  isNew: boolean;
  isFavorite: boolean;
  isLiked: boolean;
}

interface TagItem {
  tagId: number;
  tagName: string;
  createdDate: string;
}

interface DiseaseItem {
  diseaseCode?: string;
  diseaseName?: string;
  createdDate: string;
}

interface FollowItem {
  posterId?: number;
  nickname?: string;
  createdDate: string;
}

interface ArticleQueryCond {
  tagIds?: number[];
  diseaseCodes?: string[];
  posterIds?: number[];
}
// ---- Constant ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'Recommend',
  setup(__props) {

const router = useRouter();
const userArticleFavorite = new UserArticleFavorite();
const userArticleLike = new UserArticleLike();
const data = new Content();
const isExpanded = ref(false);
const searchModalOpen = ref(false);
const listTag = ref<TagItem[]>([]);
const limitedTags = ref<TagItem[]>([]);
const listDisease = ref<DiseaseItem[]>([]);
const limitedDiseases = ref<DiseaseItem[]>([]);
const listFollow = ref<FollowItem[]>([]);
const listData = ref<ArticleData[]>([]);
const expandedItems = reactive<{ [key: string]: boolean }>({});
const tagListRefs = reactive({});

// ---- variable ----------------------------------------------
let props = reactive({
  cond: { searchType: 0, searchValue: null as any }, // APIの検索条件
  size: 12,
  getTotalCount: (cond: any): Promise<number> => {
    return data.getArticlesCount(cond);
  },
  getPageData: (page: number, size: number, cond: any): Promise<any> => {
    return data.getArticles(page, size, cond);
  },
});

// セッションエラーチェック
let sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ---- Function ----------------------------------------------
// アコーディオン高さのチェック（高さ>135px)
const checkTagListHeight = (articleId: string | number): boolean => {
  const tagList = tagListRefs[articleId];
  if (tagList) {
    // total height ul (diseases and tags)
    const totalHeight = tagList.scrollHeight;
    return totalHeight > 135;
  }
  return false;
};

// トグルボタンの状態
const toggleExpand = (articleId: string | number) => {
  if (expandedItems[articleId]) {
    expandedItems[articleId] = false;
  } else {
    expandedItems[articleId] = true;
  }
};

// 一覧データ取得
const notify = (result: any) => {
  if (result.isSuccess) {
    listData.value = result.data;
    window.scrollTo({ top: 0 });
  } else {
    listData.value = [];
    const status = result.data.error?.response?.status;
    // セッションエラー
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        result.data.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
};

// タグ取得
const fetchTags = async () => {
  const tags = new Tag();
  // listTag.value
  const [_model, response, err] = await tags.getUserTags();
  if (err) {
    listTag.value = [];
    // セッションエラー
    const status = err.error?.response?.status;
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
  listTag.value = response.data.result;
};

// 疾患取得
const fetchDiseases = async () => {
  const disease = new UserDisease();
  // listTag.value
  const [_model, response, err] = await disease.getUserDisease();
  if (err) {
    listDisease.value = [];
    // セッションエラー
    const status = err.error?.response?.status;
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
  listDisease.value = response.data.result;
};

// タグと疾患を5件に絞る
const limitTagsAndDiseases = () => {
  // 疾患は古い順にソート
  const sortedDiseases = [...listDisease.value].sort(
    (a, b) =>
      new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime()
  );

  // タグは新しい順にソート
  const sortedTags = [...listTag.value].sort(
    (a, b) =>
      new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
  );

  // 全体で5件に絞る（疾患優先）
  const totalItems = [...sortedDiseases, ...sortedTags];
  const limitedItems = totalItems.slice(0, 5);

  // 疾患とタグを分離
  limitedDiseases.value = limitedItems
    .filter((item) => "diseaseCode" in item)
    .map((item) => item as DiseaseItem);

  limitedTags.value = limitedItems
    .filter((item) => "tagId" in item)
    .map((item) => item as TagItem);
};

const fetchFollow = async () => {
  const follow = new UserAuthorFollow();
  const [_model, response, err] = await follow.getUserAuthorFollows();
  if (err) {
    listFollow.value = [];
    // セッションエラー
    const status = err.error?.response?.status;
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
  }
  listFollow.value = response.data.result;
};

// 記事一覧ページへ遷移
const goToArticlePage = (cond?: ArticleQueryCond) => {
  router.push({
    name: "article/search",
    query: {
      cond: encodeURIComponent(JSON.stringify(cond)),
    },
  });
};
// 記事お気に入り更新
const updateUserArticleFavorites = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleFavorite
    .updateUserArticleFavorites(articleId)
    .then(([model, _response, err]) => {
      if (err) {
        target.checked = !target.checked;
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;
        target.checked = result;

        const article = listData.value.find((a) => a.articleId === articleId);
        if (article) {
          article.isFavorite = result;
        }
      }
    });
};

// 記事いいね情報更新
const updateUserArticleLikes = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleLike
    .updateUserArticleLikes(articleId, !target.checked)
    .then(([model, _response, err]) => {
      if (err) {
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const likeCount = model.attributes?.result;
        const article = listData.value.find((a) => a.articleId === articleId);
        if (article) {
          article.likeCount = likeCount;
          article.isLiked = !article.isLiked;
        }
      }
    });
};

// 記事詳細ページへ遷移
const goToArticleDetailPage = (articleId: number) => {
  if (!articleId) return;

  router.push({
    name: "article/detail",
    params: { articleId },
  });
};

// タイトルを38文字以内に…で切り捨てる
const truncateTitle = (title: string): string => {
  if (!title) return "";

  if (title.length > 38) {
    return title.slice(0, 37) + "…";
  }

  return title;
};
// ---- Vue lifeCycle -----------------------------------------
onMounted(async () => {
  await fetchTags();
  await fetchDiseases();
  await fetchFollow();
  limitTagsAndDiseases();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/server/necs/images/search_icon.svg" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_tag")), 1)
        ]),
        _createElementVNode("ul", _hoisted_4, [
          (!isExpanded.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedDiseases.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "search-tag tag-disease sp-only",
                    onClick: ($event: any) => (
              goToArticlePage({
                diseaseCodes: item.diseaseCode ? [item.diseaseCode] : [],
              })
            )
                  }, _toDisplayString(item.diseaseName), 9, _hoisted_5))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedTags.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "search-tag tag-interest sp-only",
                    onClick: ($event: any) => (goToArticlePage({ tagIds: [item.tagId] }))
                  }, _toDisplayString(item.tagName), 9, _hoisted_6))
                }), 128))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listDisease.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "search-tag tag-disease sp-only",
                    onClick: ($event: any) => (
              goToArticlePage({
                diseaseCodes: item.diseaseCode ? [item.diseaseCode] : [],
              })
            )
                  }, _toDisplayString(item.diseaseName), 9, _hoisted_7))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listTag.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "search-tag tag-interest sp-only",
                    onClick: ($event: any) => (goToArticlePage({ tagIds: [item.tagId] }))
                  }, _toDisplayString(item.tagName), 9, _hoisted_8))
                }), 128))
              ], 64)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listDisease.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "search-tag tag-disease pc-only",
              onClick: ($event: any) => (
            goToArticlePage({
              diseaseCodes: item.diseaseCode ? [item.diseaseCode] : [],
            })
          )
            }, _toDisplayString(item.diseaseName), 9, _hoisted_9))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listTag.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "search-tag tag-interest pc-only",
              onClick: ($event: any) => (goToArticlePage({ tagIds: [item.tagId] }))
            }, _toDisplayString(item.tagName), 9, _hoisted_10))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("article_tab_recommend_search_follow")), 1),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listFollow.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "search-writer",
                onClick: ($event: any) => (
              goToArticlePage({
                posterIds: item.posterId ? [item.posterId] : [],
              })
            )
              }, _toDisplayString(item.nickname), 9, _hoisted_14))
            }), 128))
          ])
        ]),
        _withDirectives(_createElementVNode("div", { class: "contents-search-title sp-only" }, _toDisplayString(_ctx.$t("article_tab_recommend_search_follow")), 513), [
          [_vShow, isExpanded.value]
        ]),
        _withDirectives(_createElementVNode("ul", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listFollow.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "search-writer",
              onClick: ($event: any) => (
            goToArticlePage({
              posterIds: item.posterId ? [item.posterId] : [],
            })
          )
            }, _toDisplayString(item.nickname) + _toDisplayString(_ctx.$t("article_tab_recommend_search_follow_name")), 9, _hoisted_16))
          }), 128))
        ], 512), [
          [_vShow, isExpanded.value]
        ]),
        (!isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["contents-search-all sp-only", { active: !isExpanded.value }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = true))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_show")), 1),
              _cache[5] || (_cache[5] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1))
            ], 2))
          : _createCommentVNode("", true),
        (isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["contents-search-hide sp-only", { active: isExpanded.value }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isExpanded.value = false))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_hidden")), 1),
              _cache[6] || (_cache[6] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("ul", _hoisted_17, [
      (Array.isArray(listData.value) && listData.value.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(listData.value, (article, i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "recs-contents-items",
              key: article.articleId
            }, [
              _createElementVNode("div", {
                class: "sp-wrapper",
                onClick: ($event: any) => (goToArticleDetailPage(article.articleId))
              }, [
                _createElementVNode("img", {
                  class: "content-item-img",
                  src: article.coverPhotoUrl
                }, null, 8, _hoisted_19),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["content-item-new", { none: !article.isNew }])
                  }, _toDisplayString(article.isNew ? _ctx.$t("article_new") : ""), 3),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(truncateTitle(article.title)), 1)
                ])
              ], 8, _hoisted_18),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("ul", {
                  class: _normalizeClass(["content-item-tags", { heightExpanded: expandedItems[article.articleId] }]),
                  ref_for: true,
                  ref: (el) => (tagListRefs[article.articleId] = el)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.diseases, (disease, j) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tag-item tag-disease",
                      key: j,
                      onClick: ($event: any) => (goToArticlePage({ diseaseCodes: [disease.diseaseCode] }))
                    }, _toDisplayString(disease.diseaseName), 9, _hoisted_23))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag, j) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tag-item tag-interest",
                      key: j,
                      onClick: ($event: any) => (goToArticlePage({ tagIds: [tag.tagId] }))
                    }, _toDisplayString(tag.tagName), 9, _hoisted_24))
                  }), 128))
                ], 2),
                (checkTagListHeight(article.articleId))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!expandedItems[article.articleId])
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "contents-height-all",
                            onClick: ($event: any) => (toggleExpand(article.articleId))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_show")), 1),
                            _cache[7] || (_cache[7] = _createElementVNode("img", {
                              src: "/server/necs/images/arrow-right_icon.png",
                              alt: "Show more"
                            }, null, -1))
                          ], 8, _hoisted_25))
                        : _createCommentVNode("", true),
                      (expandedItems[article.articleId])
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "contents-height-hide",
                            onClick: ($event: any) => (toggleExpand(article.articleId))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_hidden")), 1),
                            _cache[8] || (_cache[8] = _createElementVNode("img", {
                              src: "/server/necs/images/arrow-right_icon.png",
                              alt: "Show less"
                            }, null, -1))
                          ], 8, _hoisted_26))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(article.dateFirstPublished), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[9] || (_cache[9] = _createTextVNode(" 提供者：")),
                    _createElementVNode("span", {
                      class: "writer-name-area",
                      onClick: ($event: any) => (
                  goToArticlePage({ posterIds: [article.poster.adminId] })
                )
                    }, _toDisplayString(article.poster.nickname), 9, _hoisted_31)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "writer-like",
                      id: `like-toggle${i}`,
                      checked: article.isLiked,
                      onChange: (e) => updateUserArticleLikes(article.articleId, e)
                    }, null, 40, _hoisted_33),
                    _createElementVNode("label", {
                      for: `like-toggle${i}`,
                      class: "like-icon"
                    }, null, 8, _hoisted_34),
                    _withDirectives(_createElementVNode("p", null, "いいね", 512), [
                      [_vShow, article.likeCount === 0]
                    ]),
                    _withDirectives(_createElementVNode("p", null, _toDisplayString(article.likeCount), 513), [
                      [_vShow, article.likeCount > 0]
                    ])
                  ]),
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "writer-follow",
                    id: `follow-toggle${i}`,
                    checked: article.isFavorite,
                    onChange: (e) => updateUserArticleFavorites(article.articleId, e)
                  }, null, 40, _hoisted_35),
                  _createElementVNode("label", {
                    for: `follow-toggle${i}`,
                    class: "follow-icon"
                  }, null, 8, _hoisted_36)
                ])
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Pagination, _mergeProps(_unref(props), { onNotify: notify }), null, 16),
    _createElementVNode("button", {
      type: "button",
      class: "contents-list-button",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (searchModalOpen.value = true))
    }, [
      _cache[10] || (_cache[10] = _createElementVNode("img", { src: "/server/necs/images/article_search_button_icon.svg" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_search_all")), 1)
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (searchModalOpen.value)
      ? (_openBlock(), _createBlock(ModalSearch, {
          key: 1,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (searchModalOpen.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})